module.exports = __webpack_public_path__ + "static/media/au.ecef4318.svg";